module.exports = __webpack_public_path__ + "images/_/assets/images/RIG/popup_orc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RIG/popup_orc.png
// module id = ./src/assets/images/RIG/popup_orc.png
// module chunks = 1